import React, { useEffect, useRef } from "react";

const ASSET_BASE = (process.env.PUBLIC_URL || "") + "/assets/qia/";
const INTRO_SRC = ASSET_BASE + "animation_qiaIntro4-60fps.webm";
const IDLE_SRC = ASSET_BASE + "animation_idle2_1.webm";

let qiaIntroHasPlayed = false;

function RuleChatWelcome({ t, onChipSend, isEmptyTree }) {
    const videoRef = useRef(null);

    useEffect(() => {
        const video = videoRef.current;
        if (!video || qiaIntroHasPlayed) return undefined;

        const handleEnded = () => {
            qiaIntroHasPlayed = true;
            video.loop = true;
            video.src = IDLE_SRC;
            let playPromise = video.play();
            if (playPromise && playPromise.catch) playPromise.catch(() => {});
        };

        const handleError = () => {
            if (qiaIntroHasPlayed) return;
            handleEnded();
        };

        video.addEventListener("ended", handleEnded);
        video.addEventListener("error", handleError);
        return () => {
            video.removeEventListener("ended", handleEnded);
            video.removeEventListener("error", handleError);
        };
    }, []);

    
    const chips = isEmptyTree
        ? [
            t("Sugira validações comuns para este tipo de evento"),
            t("Monte uma estrutura inicial para esta regra"),
            t("Quais campos do evento posso usar?"),
            t("Quais dados externos posso consultar?")
        ]
        : [
            t("O que esta regra faz?"),
            t("Explique a última alteração"),
            t("Há algum problema nesta regra?"),
            t("Como simplificar esta regra?")
        ];

    return (
        <div className="qia-welcome">
            <video
                ref={videoRef}
                className="qia-welcome-video"
                src={qiaIntroHasPlayed ? IDLE_SRC : INTRO_SRC}
                loop={qiaIntroHasPlayed}
                muted
                autoPlay
                playsInline
            />
            <h2 className="qia-greeting qia-fadeup">
                {t("Olá! Como posso ajudar com esta regra?")}
            </h2>
            <p className="qia-subtitle qia-fadeup">
                {isEmptyTree
                    ? t("Peça sugestões ou gere validações para começar a montar sua regra.")
                    : t("Tire dúvidas ou peça análises sobre a regra que você está editando.")}
            </p>
            <div className="qia-chips qia-fadeup">
                {chips.map((chip) => (
                    <button
                        key={chip}
                        type="button"
                        className="qia-chip-btn"
                        onClick={() => onChipSend(chip)}
                    >
                        {chip}
                    </button>
                ))}
            </div>
        </div>
    );
}

export default RuleChatWelcome;
